export const LINKS = [
  {
    to: "/services",
    linkname: "Services",
  },
  {
    to: "/about",
    linkname: "About us",
  },
  {
    to: "/contact",
    linkname: "Contact",
  },
  {
    to: "/blog",
    linkname: "Blog",
  },
  {
    to: "/portfolio",
    linkname: "Portfolio",
  },
];
